import { useData} from '@inmagik/react-crud'
import { API_URL } from "../constants"
import { DomainData } from "../types"

export function useDomain() {
    return useData<DomainData>(`${API_URL}/domain`)
  }


